import React from 'react';
import { Table, Badge } from 'react-bootstrap';
import '../HRBPDetails/HRBPDetails.scss'

const RejectedNominationsTable = ({ nominations }: any) => {
    return (
        <Table striped bordered hover responsive>
            <thead>
                <tr>
                    <th>Employee ID</th>
                    <th>Employee Name</th>
                    <th>Employee E-Mail ID</th>
                    <th>Employee Status</th>
                    <th>Employee Designation</th>
                    <th>Employee Department</th>
                    <th>Employee Project Classification</th>
                    <th>Nominated By</th>
                    <th>Award Category</th>
                    <th>Nominated On</th>
                    <th>Nomination Reason</th>
                    <th>Reviewed By (HR/HRBP)</th>
                    <th>Reviewed On</th>
                    <th>Rejection Review Remarks</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {nominations.length > 0 ? (
                    nominations.map((nomination: any) => (
                        <tr key={nomination._id}>
                            <td>{`${nomination?.employeeRef?.employeeId || ''}`}</td>
                            <td>{`${nomination.employeeRef?.candidateName || ''} ${nomination.employeeRef?.lastname || ''}`}</td>
                            <td>{`${nomination?.employeeRef?.emailId || ''}`}</td>
                            <td>
                                <button
                                    type="button"
                                    className={
                                    `${nomination?.employeeRef?.status}` === 'Active'
                                        ? "btn employeedb-status-btn employee-active-btn"
                                        : `${nomination?.employeeRef?.status}` === "Inactive"
                                        ? "btn employeedb-status-btn employee-inactive-btn"
                                        : `${nomination?.employeeRef?.status}` === "New"
                                            ? "btn employeedb-status-btn employee-new-btn"
                                            : "btn employeedb-status-btn employee-draft-btn"
                                    }
                                >
                                    {`${nomination?.employeeRef?.status}` || ''} 
                                </button>
                            </td>
                            <td>{`${nomination?.employeeRef?.designation || ''}`}</td>
                            <td>{`${nomination?.employeeRef?.department || ''} - ${nomination.employeeRef?.subDepartment || ''}`}</td>
                            <td>{`${nomination?.employeeRef?.projectType || ''} - ${nomination?.employeeRef?.projectClassification || ''}`}</td>
                            <td>{`${nomination.nominatedByRef?.candidateName || ''} ${nomination.nominatedByRef?.lastname || ''}`}</td>
                            <td>{nomination.awardRef?.awardCategory || 'N/A'}</td>
                            <td>{new Date(nomination.createdAt).toLocaleDateString()}</td>
                            <td>{`${nomination?.justification || 'N/A'}`}</td>
                            <td>{`${nomination.reviewedByRef?.candidateName || ''} ${nomination.reviewedByRef?.lastname || 'N/A'}`}</td>
                            <td>{new Date(nomination.reviewedAt).toLocaleDateString()}</td>
                            <td>{`${nomination?.hrbpRemarks || 'N/A'}`}</td>           
                            <td><Badge bg="danger">{nomination.status}</Badge></td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={5} className="text-center">No rejected nominations found.</td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};

export default RejectedNominationsTable;